(function(){
    angular
        .module('app')
        .directive('stringToNumber', stringToNumber);

        stringToNumber.$inject = ['$timeout'];
        function stringToNumber($timeout){
            return {
	            require: 'ngModel',
	            link: function(scope, element, attrs, ngModel) {
					      ngModel.$parsers.push(function(value) {
					        return '' + value;
					      });
					      ngModel.$formatters.push(function(value) {
					        return parseFloat(value);
					      });
				}
        	}
        }
})();